import { Component, Input } from '@angular/core';
import { AppContext} from 'controls';
import { RequestRoot } from 'types';
import { PrintFromV1 } from '../request-print-form-v1';
import { IPrintDepartment } from '../../model/print-department';
import { PrintQRCodeGenerationService } from '../../service/print-qrcode-generation.service';

@Component({
  selector: 'child-request-form-v1',
  templateUrl: './child-request-form-v1.component.html',
  styleUrls: ['./child-request-form-v1.component.scss']
})
export class ChildRequestFormV1Component extends PrintFromV1 {
    @Input() model: RequestRoot;
    @Input() department: IPrintDepartment;
    @Input() version: string;

    constructor(
        appContext: AppContext,
        qrCodeService: PrintQRCodeGenerationService
    ) { super(appContext, qrCodeService); }
}
